<script setup>
import SectionTitle from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/components/SectionTitle.vue'
import OContentsRow from '@weathernews/mi-web-design/organisms/OContentsRow.vue'
import ALinkItem from '@weathernews/mi-web-design/atoms/ALinkItem.vue'

const title = 'レーダーコンテンツ一覧'
const contents = [
  {
    title: '風レーダー',
    link: 'https://weathernews.jp/onebox/wind/',
    file: 'https://gvs.weathernews.jp/onebox/img/common/menu/wind.webp'
  },
  {
    title: '雨雲レーダー',
    link: 'https://weathernews.jp/onebox/radar/',
    file: 'https://gvs.weathernews.jp/onebox/img/common/menu/radar.webp'
  },
  {
    title: '雷レーダー',
    link: 'https://weathernews.jp/onebox/thunder/',
    file: 'https://gvs.weathernews.jp/onebox/img/common/menu/thunder.webp'
  },
  {
    title: '世界の雨雲レーダー',
    link: 'https://weathernews.jp/onebox/tenki/world/radar/',
    file: 'https://gvs.weathernews.jp/onebox/img/common/menu/world_radar.webp'
  }
]
</script>

<template>
  <div class="topicList_box">
    <SectionTitle :title="title" />
    <OContentsRow>
      <template
        v-for="(item, index) in contents"
        :key="index"
      >
        <ALinkItem data-type="card">
          <a :href="item.link">
            <p>{{ item.title }}</p>
            <figure>
              <img
                :src="item.file"
                width="165"
                height="131"
                alt=""
                loading="lazy"
              >
            </figure>
          </a>
        </ALinkItem>
      </template>
    </OContentsRow>
  </div>
</template>

<style lang="scss" scoped>
.topicList_box {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
</style>
